import {
  CardElement,
  Elements,
  PaymentElement,
  useElements,
  useStripe
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useState } from "react";
import styles from './scss/stripe_payment.module.scss';
import { API_HOST } from "../config";
import { API_ROUTE_CONTROLLER } from "../service/route";
import { STRIPE_LIVE_PK_KEY, STRIPE_TEST_PK_KEY } from "../service/constant";
import { API_PAYMENT_CONFIG } from "../app/base/constant";
const Stripe =({amount,currency=API_PAYMENT_CONFIG.site_currency,onPaymentResult}) => {
  const [publishableKey] = useState(STRIPE_LIVE_PK_KEY);
  // const [publishableKey] = useState(STRIPE_TEST_PK_KEY);


  const stripePromise = loadStripe(publishableKey);
  const options = {
    mode: "payment",
    amount: Math.round(Number(amount) * 100),
    currency: currency.toLowerCase(),
    appearance: {
      theme: "stripe",
      variables: {
        fontWeightNormal: "500",
        borderRadius: "2px",
        colorPrimary: "#f360a6",
        tabIconSelectedColor: "#fff",
        gridRowSpacing: "16px",
      },
      rules: {
        ".Tab, .Input, .Block, .CheckboxInput, .CodeInput": {
          boxShadow: "none",
          border: "1px solid #D2D3D4",
          borderRadius: "6px",
        },
        ".Input--invalid": {
          boxShadow: "none",
        },
        ".Block": {
          borderColor: "transparent",
        },
        ".BlockDivider": {
          backgroundColor: "#ebebeb",
        },
        ".Tab, .Tab:hover, .Tab:focus": {
          border: "0",
        },
        ".Tab--selected, .Tab--selected:hover": {
          backgroundColor: "#f360a6",
          color: "#fff",
        },
        ".Label": {
          background: "#828385",
          marginBottom: "8px",
        },
        ".Error": {
          fontSize: "12px",
        },
      },
    },
  };

  const CheckoutForm = () => {
    const stripe = useStripe();
    const elements = useElements();
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const handleSubmit = async (e) => {
      e.preventDefault();
      setIsLoading(true);

      if (!stripe || !elements) return;

      const { error: submitError } = await elements.submit();
      if (submitError) {
        setErrorMessage(submitError.message);
        setIsLoading(false);
        return;
      }
    let url = API_ROUTE_CONTROLLER.stripe_payment_v1;
    // let url = API_ROUTE_CONTROLLER.qastripe_payment_v1;
    // let url = `http://localhost:5006/myaccount-mysql/v1/payment/qapayment_v1`
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify({
          amount: Math.round(Number(amount) * 100),
          currency: currency.toLowerCase(),
          description: "worktual pricing",
        }),
      });

      const { clientSecret } = await res.json();
      console.log("clientSecret", clientSecret)
      const { paymentIntent, error } = await stripe.confirmPayment({
        elements,
        clientSecret,
        confirmParams: {
          return_url: window.location.href.split('?')[0],
        },
        redirect: "if_required",
      });
      //   const { paymentIntent, error } = await stripe.confirmCardPayment(clientSecret, {
      //   payment_method: {
      //     card: elements.getElement(CardElement),
      //     billing_details:{
      //       name:"test",
      //       address:{
      //         country:""
      //       }
      //     }
      //   },
      // });

      if (error) {
        setErrorMessage(error.message);
        onPaymentResult?.({ status: "failed", error });
      } else if (paymentIntent.status === "succeeded") {
        onPaymentResult?.({ status: "succeeded", paymentIntent });
      } else {
        onPaymentResult?.({ status: paymentIntent.status, payment: paymentIntent });
      }

      setIsLoading(false);
    };

    return (
      <div className={styles.stripeformcontainer}>
        <form onSubmit={handleSubmit}>
          <PaymentElement />
          <div className={styles.btns}>
            <button className={styles.cardpaybtn} type="submit" disabled={!stripe || !elements || isLoading}>
              {isLoading ? "Processing" : "Pay"}
            </button>

          </div>
          {/* {errorMessage && <div >Error: {errorMessage}</div>} */}
        </form>
      </div>
    );
  };

  return (
    <div>
      <Elements stripe={stripePromise} options={options}>
        <CheckoutForm />
      </Elements>
    </div>
  );
}

export default Stripe;